import React from 'react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-800 to-gray-900 text-white py-16">
      <div className="max-w-6xl mx-auto px-5">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="font-dm-sans font-bold text-secondary text-xl mb-4">Chef Aparna Singh</h3>
            <p className="text-gray-300 leading-relaxed mb-4">Creating memorable gourmet treats with passion, tradition, and innovation. Every dish is crafted with love and the finest ingredients.</p>
            <div className="bg-pink-900/20 p-4 rounded-xl border-l-4 border-primary">
              <span className="italic text-secondary block mb-2">"Every bite of dessert is a story of passion, precision, and persistence"</span>
              <p className="text-gray-400 text-sm">- Chef Aparna Singh</p>
            </div>
          </div>

          <div>
            <h4 className="font-dm-sans font-semibold text-secondary text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-300 hover:text-secondary transition-colors duration-300"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-secondary transition-colors duration-300"
                >
                  About Chef
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('menu')}
                  className="text-gray-300 hover:text-secondary transition-colors duration-300"
                >
                  Our Menu
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-secondary transition-colors duration-300"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-dm-sans font-semibold text-secondary text-lg mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-secondary transition-colors duration-300"
                >
                  Custom Cake Design
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-secondary transition-colors duration-300"
                >
                  Corporate Orders & Gifting
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-secondary transition-colors duration-300"
                >
                  Event Pop-Ups & Stalls
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-dm-sans font-semibold text-secondary text-lg mb-4">Follow Us</h4>

            <div className="flex space-x-4">
              <a href="https://www.instagram.com/vanillasky_bakehouse/">
                <button className="w-10 h-10 bg-pink-900/20 rounded-full flex items-center justify-center text-white hover:bg-primary hover:-translate-y-1 transition-all duration-300">
                  <i className="fab fa-instagram"></i>
                </button>
              </a>
              <a href="https://www.facebook.com/share/15jUHemNFC/?mibextid=wwXIfr">
                <button className="w-10 h-10 bg-pink-900/20 rounded-full flex items-center justify-center text-white hover:bg-primary hover:-translate-y-1 transition-all duration-300">
                  <i className="fab fa-facebook"></i>
                </button>
              </a>


            </div>
          </div>
        </div>

        <div className="text-center pt-8 border-t border-gray-700">
          <p className="text-gray-400">&copy; 2025 Vanilla Sky. All rights reserved. | Crafted with ❤️ in India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 